import React from "react";

/**
 * Compact ±1 number spinner with decrement/value/increment buttons.
 */
export function NumberSpinner({
  value,
  onDecrement,
  onIncrement,
  min = 1,
  size = "md",
}: {
  value: number;
  onDecrement: () => void;
  onIncrement: () => void;
  min?: number;
  size?: "sm" | "md";
}) {
  const btn = size === "sm" ? "w-6 h-6" : "w-7 h-7";
  const text = size === "sm" ? "text-micro" : "text-sm";

  return (
    <span
      className={`inline-flex items-center border border-term-border rounded ${text} leading-none`}
    >
      <button
        onClick={onDecrement}
        className={`${btn} bg-term-raised text-term-text-dim hover:bg-term-border-bright hover:text-term-text cursor-pointer transition-colors flex items-center justify-center rounded-l`}
        disabled={value <= min}
      >
        −
      </button>
      <span
        className={`${btn} flex items-center justify-center font-medium text-term-text-dim bg-term-surface border-x border-term-border`}
      >
        {value}
      </span>
      <button
        onClick={onIncrement}
        className={`${btn} bg-term-raised text-term-text-dim hover:bg-term-border-bright hover:text-term-text cursor-pointer transition-colors flex items-center justify-center rounded-r`}
      >
        +
      </button>
    </span>
  );
}
